var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.43258 12.0873L3.73639 14.6863L1.1918 14.7401C0.431344 13.3296 0 11.7158 0 10.0009C0 8.34263 0.403296 6.77882 1.11817 5.40186H1.11871L3.38411 5.81718L4.37649 8.06898C4.16879 8.67451 4.05558 9.32454 4.05558 10.0009C4.05566 10.735 4.18863 11.4384 4.43258 12.0873Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8255 8.13232C19.9404 8.73727 20.0002 9.36202 20.0002 10.0005C20.0002 10.7165 19.925 11.4149 19.7816 12.0885C19.2947 14.3809 18.0227 16.3826 16.2606 17.7992L16.26 17.7986L13.4066 17.653L13.0028 15.132C14.1721 14.4463 15.0858 13.3732 15.5672 12.0885H10.2197V8.13232H15.6452H19.8255Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.2615 17.7982L16.2621 17.7987C14.5483 19.1762 12.3713 20.0004 10.0014 20.0004C6.19305 20.0004 2.88196 17.8718 1.19287 14.7393L4.43365 12.0864C5.27818 14.3403 7.45243 15.9448 10.0014 15.9448C11.0971 15.9448 12.1235 15.6486 13.0043 15.1316L16.2615 17.7982Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3826 2.30227L13.1429 4.95456C12.2313 4.38477 11.1538 4.05562 9.99939 4.05562C7.39269 4.05562 5.17776 5.73369 4.37555 8.06842L1.11773 5.40129H1.11719C2.78154 2.19238 6.1344 0 9.99939 0C12.4258 0 14.6506 0.864328 16.3826 2.30227Z",
    fill: "#F14336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.f7e285117418cb08668269d88b63a1af.svg";
export { ForwardRef as ReactComponent };